import { useAuth0 } from "@auth0/auth0-react";
import { useRoles } from "hooks/useRoles";
import { useUsers } from "hooks/useUsers";

export const useIsOwner = () => {
  const { roles } = useRoles(false);
  const { user } = useAuth0();
  const { users } = useUsers(false);

  const getIsOwner = () => {
    if (roles.length && users.length) {
      const ownerRoleId = roles.find((role) => role.name.toLowerCase() === "owner").id;
      const userRoleId = users.find((item) => item.auth0_id === user?.cxfUserId)?.role_id;

      return ownerRoleId === userRoleId;
    }

    return false;
  };

  return getIsOwner();
};
